/* eslint-disable prefer-destructuring */
export const TIME_OUT = Number.parseInt(process.env.TIME_OUT, 10);

export const BASE_APPLICATION_HOST = process.env.BASE_APPLICATION_HOST;

export const BFF_WEB_HOST = process.env.BFF_WEB_HOST;

export const BFF_WEB_PORT = process.env.BFF_WEB_PORT;

export const BFF_WEB_PATH = process.env.BFF_WEB_PATH;

export const APP_VERSION = process.env.APP_VERSION;

export const APP_BRANCH = process.env.APP_BRANCH;

export const MEDIUM_FEEDS_URL = process.env.MEDIUM_FEEDS_URL;

export const TRACK_JS_TOKEN = process.env.TRACK_JS_TOKEN;

export const TRACK_JS_APPLICATION = process.env.TRACK_JS_APPLICATION;

export const PARTNER_PORTAL_APP_STORE_URL = process.env.PARTNER_PORTAL_APP_STORE_URL;

export const STATIC_IMAGES_HOST = process.env.STATIC_IMAGES_HOST;

export const RECAPTCHA_SITE_ID = process.env.REACT_APP_RECAPTCHA_SITE_ID;
